<template>
  <section>
    <div class="container">
      <div class="handle-box">
        <router-link :to="{ path: '/dtype/add', query: { id: 0 } }" v-if="isadmin">
          <el-button size="small" type="primary" icon="el-icon-plus"
            >添加</el-button
          >
        </router-link>
      </div>

      <el-table
        :data="tableData"
        stripe
        @selection-change="checkIds"
        v-loading="loading"
      >
        <el-table-column
          type="selection"
          width="65"
          align="right"
        ></el-table-column>
        <el-table-column
          prop="dtid"
          label="ID"
          align="center"
          v-if="false"
        ></el-table-column>
        <el-table-column prop="type_name" label="类型名称" align="center">
        </el-table-column>
        <el-table-column prop="type_code" label="类型编号" align="center">
        </el-table-column>
        <el-table-column prop="type_price" label="服务价格" align="center">
          <div slot-scope="scope">
            {{ scope.row.type_price }}&nbsp;&nbsp;&nbsp;元/年
          </div>
        </el-table-column>
        <el-table-column label="设备" align="center">
          <div slot-scope="scope">
            <router-link
              :to="{ path: '/dev/list', query: { dtid: scope.row.dtid } }"
              ><a href="javascript:void(0)">设备列表</a></router-link
            >
          </div>
        </el-table-column>
        <el-table-column label="变量" align="center">
          <div slot-scope="scope">
            <router-link
              :to="{ path: '/var/list', query: { dtid: scope.row.dtid } }"
            >
              <a href="javascript:void(0)">变量定义</a>
            </router-link>
          </div>
        </el-table-column>

        <el-table-column prop="name" label="操作" align="center" width="200">
          <div slot-scope="scope">
            <router-link
              v-if="!isadmin"
              :to="{ path: '/dtype/update', query: { id: scope.row.dtid } }"
            >
              <el-button class="ml10" type="text" icon="el-icon-edit"
                >详情</el-button
              >
            </router-link>
            <router-link
              v-if="isadmin"
              :to="{ path: '/dtype/update', query: { id: scope.row.dtid } }"
            >
              <el-button class="ml10" type="text" icon="el-icon-edit"
                >修改</el-button
              >
            </router-link>
            <el-button
              v-if="isadmin"
              type="text"
              icon="el-icon-delete"
              class="red ml10"
              @click="del('DevType/Delete', scope.row.dtid)"
              >删除</el-button
            >
          </div>
        </el-table-column>
        <el-table-column label="组态" align="center" width="300">
          <div slot-scope="scope">
            <!-- <router-link
              v-if="scope.row.view_url"
              :to="{
                path: '/viewconf/check',
                query: {
                  cfid: scope.row.view_url,
                  dtid: scope.row.dtid,
                  guid: 0,
                  isLive: 0
                }
              }"
            >
              <el-button class="ml10" type="text" icon="el-icon-thumb"
                >查看</el-button
              >
            </router-link> -->
            <router-link
              v-if="!scope.row.view_url"
              :to="{
                path: '/viewconf/add',
                query: { cfid: 0, dtid: scope.row.dtid, guid: 0, isLive: 0 }
              }"
            >
              <el-button class="ml10" type="text" icon="el-icon-edit"
                >创建</el-button
              >
            </router-link>
            <router-link
              v-if="scope.row.view_url"
              :to="{
                path: '/viewconf/update',
                query: {
                  cfid: scope.row.view_url,
                  dtid: scope.row.dtid,
                  guid: 0,
                  isLive: 0
                }
              }"
            >
              <el-button class="ml10" type="text" icon="el-icon-edit"
                >编辑</el-button
              >
            </router-link>
            <el-button
              type="text"
              icon="el-icon-delete"
              class="red ml10"
              v-if="scope.row.view_url"
              @click="deleteViewConf('ViewConf/Delete', scope.row.view_url)"
              >删除</el-button
            >
          </div>
        </el-table-column>
      </el-table>

      <!-- 表格底部 -->
      <div class="cms-list-footer">
        <div class="cms-left">
          <el-button
            size="small"
            :disabled="disabled"
            v-show="isadmin"
            @click="deleteBatch('DevType/Delete', ids)"
            >批量删除</el-button
          >
        </div>
        <!-- 分页组件 -->
        <cms-pagination :total="total" @change="getPages"></cms-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import va from "@/rules";
import formMixns from "@/mixins/form";
import listMixins from "@/mixins/list";

export default {
  name: "DevType",
  mixins: [listMixins, formMixns],
  data() {
    let required = va.required("此项必填");
    let validateCode = va.validateCode(
      "设备类型编号已存在",
      "DevType/IsExist",
      ""
    );
    return {
      params: {
        //只需要业务参数
        pageNo: "1",
        pageSize: "10"
      },
      rules: {
        // 校验规则
        type_code: [required, validateCode],
        type_name: [required]
      },
      pictures: [],
      isadmin: false,
      diaIsShow: false,
      editType: "",
      diaTitle: "",
      rowIndex: 0
    };
  },
  mounted() {},
  methods: {
    checkIds(val) {
      let ids = [];
      for (let i in val) {
        ids.push(val[i].dtid);
      }
      this.ids = ids.join(",");
      this.disabled = val.length > 0 ? false : true;
      this.checkedList = val;
    },
    del(val1, val2) {
      this.deleteBatch(val1, val2);
    }
  },
  created() {
    //获取信息
    if(this.$store.state.userInfo.role===2){//如果是经销商，则取其名下设备类型
      this.params.uid=this.$store.state.userInfo.id;
    }
    this.initTableData("DevType/Paged", this.params);
    this.loading = false;
    this.isadmin = this.$isAdmin();
  },
  watch:{
    // 修复增改之后，重新加载页面，无法执行 created  函数
    $route(to, from) {
      if(to.fullPath.indexOf('/dtype/list')==-1)
      {
        return;
      }
      if(this.$store.state.userInfo.role===2){//如果是经销商，则取其名下设备类型
        this.params.uid=this.$store.state.userInfo.id;}
        this.initTableData("DevType/Paged", this.params);
        this.loading = false;
        this.isadmin = this.$isAdmin();
    }
  }
};
</script>
